import React from 'react';
import { useNavigation } from '../NavigationContext';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;0,900;1,700&family=Inter:wght@300;400;500;600;700;800&display=swap');

  .el-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .el-page { font-family: 'Inter', sans-serif; color: #0d1b3e; background: #ffffff; width: 100%; }

  /* ── Hero ── */
  .el-hero { position: relative; padding: 100px 24px 120px; overflow: hidden; background: #fff; }
  .el-hero-blob1 { position: absolute; top: -10%; right: -5%; width: 600px; height: 600px; border-radius: 50%; background: radial-gradient(circle, rgba(124,58,237,0.07), rgba(13,27,62,0.04)); filter: blur(90px); pointer-events: none; }
  .el-hero-blob2 { position: absolute; bottom: -15%; left: -10%; width: 700px; height: 700px; border-radius: 50%; background: radial-gradient(circle, rgba(30,58,138,0.07), rgba(124,58,237,0.04)); filter: blur(90px); pointer-events: none; }
  .el-hero-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: center; position: relative; z-index: 1; }
  @media (max-width: 900px) { .el-hero-inner { grid-template-columns: 1fr; } .el-hero-card { display: none; } }

  .el-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; border-radius: 999px; background: #f5f3ff; border: 1px solid #ddd6fe; font-size: 13px; font-weight: 500; color: #5b21b6; margin-bottom: 28px; }
  .el-badge-dot { width: 8px; height: 8px; border-radius: 50%; background: #7c3aed; display: inline-block; animation: el-pulse 2s ease-in-out infinite; }
  @keyframes el-pulse { 0%, 100% { box-shadow: 0 0 0 0 rgba(124,58,237,0.5); } 50% { box-shadow: 0 0 0 6px rgba(124,58,237,0); } }

  .el-hero h1 { font-family: 'Playfair Display', Georgia, serif; font-size: clamp(1.8rem, 3.375vw, 2.85rem); font-weight: 800; line-height: 1.1; letter-spacing: -0.02em; color: #0d1b3e; margin-bottom: 24px; }
  .el-gradient-text { background: linear-gradient(135deg, #7c3aed 0%, #0d1b3e 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .el-hero-sub { font-size: 1.1rem; color: #475569; line-height: 1.8; margin-bottom: 40px; }
  .el-btn-group { display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 44px; }
  .el-btn-primary { padding: 14px 28px; background: #0d1b3e; color: #fff; border: none; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: all 0.2s; }
  .el-btn-primary:hover { background: #7c3aed; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(124,58,237,0.3); }
  .el-back-btn { display: flex; width: fit-content; align-items: center; gap: 8px; font-size: 14px; font-weight: 600; color: #7c3aed; background: none; border: none; cursor: pointer; padding: 0; margin-bottom: 24px; transition: color 0.2s; }
  .el-back-btn:hover { color: #5b21b6; }
  .el-btn-secondary { padding: 14px 28px; background: #fff; color: #0d1b3e; border: 1.5px solid #cbd5e1; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .el-btn-secondary:hover { border-color: #7c3aed; color: #5b21b6; background: #f5f3ff; }
  .el-trust-items { display: flex; gap: 24px; flex-wrap: wrap; }
  .el-trust-item { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #64748b; font-weight: 500; }
  .el-trust-check { width: 20px; height: 20px; background: #ede9fe; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 10px; color: #7c3aed; flex-shrink: 0; }

  /* Hero Card */
  .el-hero-card { background: #fff; border-radius: 24px; border: 1px solid #e2e8f0; padding: 32px; box-shadow: 0 24px 64px rgba(13,27,62,0.09), 0 4px 16px rgba(0,0,0,0.04); }
  .el-card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; padding-bottom: 16px; border-bottom: 1px solid #f1f5f9; }
  .el-card-title-label { font-size: 12px; color: #94a3b8; font-weight: 500; margin-bottom: 3px; }
  .el-card-title-value { font-size: 15px; font-weight: 700; color: #0d1b3e; }
  .el-card-live-badge { background: #f5f3ff; color: #5b21b6; font-size: 11px; font-weight: 600; padding: 4px 10px; border-radius: 999px; }
  .el-doc-item { display: flex; align-items: center; justify-content: space-between; padding: 11px 14px; border-radius: 10px; background: #f8fafc; border: 1px solid #f1f5f9; margin-bottom: 8px; }
  .el-doc-left { display: flex; align-items: center; gap: 10px; }
  .el-doc-icon { font-size: 16px; }
  .el-doc-name { font-size: 13px; font-weight: 600; color: #334155; }
  .el-doc-sub { font-size: 11px; color: #94a3b8; margin-top: 1px; }
  .el-doc-badge { font-size: 11px; font-weight: 600; padding: 3px 10px; border-radius: 999px; white-space: nowrap; }
  .el-doc-done { background: #ede9fe; color: #5b21b6; }
  .el-doc-draft { background: #fef9c3; color: #854d0e; }
  .el-doc-new { background: #dcfce7; color: #166534; }
  .el-card-metric { margin-top: 14px; padding: 16px 18px; background: linear-gradient(135deg, #4c1d95, #7c3aed); border-radius: 12px; display: flex; justify-content: space-between; align-items: center; }
  .el-metric-label { font-size: 11px; color: rgba(255,255,255,0.75); margin-bottom: 3px; }
  .el-metric-value { font-size: 22px; font-weight: 800; color: #fff; }
  .el-metric-badge { background: rgba(255,255,255,0.2); border: 1px solid rgba(255,255,255,0.3); border-radius: 999px; padding: 4px 12px; font-size: 11px; font-weight: 600; color: #fff; }

  /* ── Stats ── */
  .el-stats { border-top: 1px solid #f1f5f9; border-bottom: 1px solid #f1f5f9; }
  .el-stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); max-width: 1200px; margin: 0 auto; }
  @media (max-width: 768px) { .el-stats-grid { grid-template-columns: 1fr 1fr; } }
  .el-stat-item { padding: 36px 24px; text-align: center; border-right: 1px solid #f1f5f9; }
  .el-stat-item:last-child { border-right: none; }
  @media (max-width: 768px) { .el-stat-item:nth-child(2n) { border-right: none; } .el-stat-item { border-bottom: 1px solid #f1f5f9; } }
  .el-stat-num { font-family: 'Playfair Display', serif; font-size: 2.2rem; font-weight: 800; color: #7c3aed; letter-spacing: -0.03em; line-height: 1; margin-bottom: 8px; }
  .el-stat-label { font-size: 0.82rem; color: #64748b; font-weight: 500; }

  /* ── Shared ── */
  .el-section { padding: 96px 24px; }
  .el-container { max-width: 1200px; margin: 0 auto; }
  .el-section-header { text-align: center; max-width: 720px; margin: 0 auto 64px; }
  .el-section-header h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .el-section-header p { font-size: 1.05rem; color: #64748b; line-height: 1.78; }
  .el-kicker { font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #7c3aed; margin-bottom: 12px; }

  /* ── Services ── */
  .el-services-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); border-bottom: 1px solid rgba(226,232,240,0.6); }
  .el-services-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  @media (max-width: 960px) { .el-services-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 600px) { .el-services-grid { grid-template-columns: 1fr; } }
  .el-svc-card { background: #fff; padding: 32px 28px; border-radius: 20px; border: 1px solid rgba(226,232,240,0.7); box-shadow: 0 1px 4px rgba(0,0,0,0.03); transition: all 0.3s; position: relative; overflow: hidden; }
  .el-svc-card:hover { box-shadow: 0 16px 48px rgba(0,0,0,0.08); transform: translateY(-3px); }
  .el-svc-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px; opacity: 0; transition: opacity 0.3s; border-radius: 20px 20px 0 0; background: linear-gradient(90deg, #7c3aed, #a78bfa); }
  .el-svc-card:hover::before { opacity: 1; }
  .el-svc-icon { font-size: 28px; margin-bottom: 16px; }
  .el-svc-title { font-size: 1rem; font-weight: 700; color: #0d1b3e; margin-bottom: 10px; }
  .el-svc-desc { font-size: 0.88rem; color: #64748b; line-height: 1.72; }

  /* ── Liability Section ── */
  .el-liab-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 72px; align-items: start; }
  @media (max-width: 900px) { .el-liab-grid { grid-template-columns: 1fr; gap: 48px; } }
  .el-liab-left h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3vw, 2.5rem); font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; line-height: 1.2; margin-bottom: 18px; }
  .el-liab-left p { font-size: 1rem; color: #64748b; line-height: 1.78; margin-bottom: 32px; }
  .el-liab-items { display: flex; flex-direction: column; gap: 16px; }
  .el-liab-item { display: flex; gap: 16px; padding: 16px 18px; background: #fff; border-radius: 14px; border: 1px solid #ede9fe; }
  .el-liab-icon-wrap { width: 40px; height: 40px; border-radius: 10px; background: #ede9fe; display: flex; align-items: center; justify-content: center; font-size: 18px; flex-shrink: 0; }
  .el-liab-title { font-size: 0.95rem; font-weight: 700; color: #0d1b3e; margin-bottom: 4px; }
  .el-liab-desc { font-size: 0.85rem; color: #64748b; line-height: 1.6; }
  .el-checklist { display: flex; flex-direction: column; gap: 14px; }
  .el-checklist-item { display: flex; align-items: flex-start; gap: 14px; padding: 16px 18px; background: #f8fafc; border-radius: 14px; border: 1px solid #f1f5f9; }
  .el-check-icon { width: 28px; height: 28px; border-radius: 8px; background: #ede9fe; display: flex; align-items: center; justify-content: center; font-size: 13px; color: #7c3aed; font-weight: 700; flex-shrink: 0; margin-top: 1px; }
  .el-check-title { font-size: 0.92rem; font-weight: 700; color: #0d1b3e; margin-bottom: 3px; }
  .el-check-desc { font-size: 0.84rem; color: #64748b; line-height: 1.55; }

  /* ── Process ── */
  .el-process-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); border-bottom: 1px solid rgba(226,232,240,0.6); }
  .el-process-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 40px; position: relative; }
  @media (max-width: 768px) { .el-process-grid { grid-template-columns: 1fr; } }
  .el-process-grid::before { content: ''; position: absolute; top: 27px; left: 16.66%; right: 16.66%; height: 2px; background: linear-gradient(90deg, #7c3aed, #a78bfa); z-index: 0; }
  @media (max-width: 768px) { .el-process-grid::before { display: none; } }
  .el-process-step { text-align: center; position: relative; z-index: 1; }
  .el-process-num { width: 56px; height: 56px; border-radius: 50%; background: #0d1b3e; color: #fff; font-size: 1rem; font-weight: 800; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; border: 4px solid #f8fafc; box-shadow: 0 0 0 2px #0d1b3e; }
  .el-process-title { font-size: 0.95rem; font-weight: 700; color: #0d1b3e; margin-bottom: 8px; }
  .el-process-desc { font-size: 0.85rem; color: #64748b; line-height: 1.65; }

  /* ── CTA ── */
  .el-cta { background: linear-gradient(135deg, #0d1b3e 0%, #4c1d95 60%, #0d1b3e 100%); padding: 96px 24px; position: relative; overflow: hidden; }
  .el-cta-blob1 { position: absolute; top: -80px; right: -60px; width: 380px; height: 380px; border-radius: 50%; background: rgba(167,139,250,0.08); filter: blur(60px); pointer-events: none; }
  .el-cta-blob2 { position: absolute; bottom: -60px; left: -40px; width: 320px; height: 320px; border-radius: 50%; background: rgba(255,255,255,0.04); filter: blur(60px); pointer-events: none; }
  .el-cta-inner { max-width: 720px; margin: 0 auto; text-align: center; position: relative; z-index: 1; }
  .el-cta-tag { display: inline-block; background: rgba(167,139,250,0.18); border: 1px solid rgba(167,139,250,0.35); border-radius: 999px; padding: 6px 16px; font-size: 12px; font-weight: 700; color: #c4b5fd; letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 24px; }
  .el-cta h2 { font-family: 'Playfair Display', serif; font-size: clamp(2rem, 4vw, 3rem); font-weight: 800; color: #fff; margin-bottom: 20px; line-height: 1.2; letter-spacing: -0.02em; }
  .el-cta p { font-size: 1.1rem; color: rgba(255,255,255,0.78); line-height: 1.75; margin-bottom: 44px; }
  .el-cta-btn-group { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; margin-bottom: 36px; }
  .el-cta-btn-primary { padding: 16px 32px; background: #7c3aed; color: #fff; border: none; border-radius: 10px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; }
  .el-cta-btn-primary:hover { background: #6d28d9; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(124,58,237,0.4); }
  .el-cta-btn-secondary { padding: 16px 32px; background: transparent; color: #fff; border: 1.5px solid rgba(255,255,255,0.35); border-radius: 10px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .el-cta-btn-secondary:hover { border-color: rgba(255,255,255,0.65); background: rgba(255,255,255,0.07); }
  .el-cta-reassurances { display: flex; gap: 24px; justify-content: center; flex-wrap: wrap; }
  .el-cta-reassurance { display: flex; align-items: center; gap: 8px; font-size: 13px; color: rgba(255,255,255,0.7); font-weight: 500; }
  .el-cta-check { width: 18px; height: 18px; background: rgba(167,139,250,0.22); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 9px; color: #c4b5fd; flex-shrink: 0; }
`;

const docItems = [
  { icon: "📖", name: "Employee Handbook", sub: "Updated Q1 2025", badge: "Current", badgeClass: "el-doc-done" },
  { icon: "📝", name: "Offer Letter Template", sub: "Standard & Executive", badge: "Done", badgeClass: "el-doc-done" },
  { icon: "⚠️", name: "Non-Compete Agreement", sub: "State-specific review", badge: "In Draft", badgeClass: "el-doc-draft" },
  { icon: "✅", name: "I-9 Compliance Checklist", sub: "Employment verification", badge: "New", badgeClass: "el-doc-new" },
];

const services = [
  { icon: "📖", title: "Employee Handbooks", desc: "Professionally drafted handbooks covering every policy your employees need to know — from PTO to code of conduct." },
  { icon: "📝", title: "Employment Contracts", desc: "Offer letters, executive agreements, contractor vs. employee classification, and non-compete clauses tailored to your state." },
  { icon: "⚖️", title: "Wage & Hour Compliance", desc: "Avoid costly FLSA violations. We audit your pay practices, overtime policies, and exempt/non-exempt classifications." },
  { icon: "🛡️", title: "Harassment & Discrimination Policy", desc: "Comprehensive workplace policies and investigation procedures that protect both employees and your business." },
  { icon: "🚪", title: "Termination & Offboarding", desc: "Proper termination procedures, severance agreements, and final pay compliance to minimize wrongful termination risk." },
  { icon: "🔄", title: "HR Policy Audits", desc: "Annual review of all HR policies and employment practices to ensure they remain compliant with current law." },
];

const liabilities = [
  { icon: "💸", title: "Wage Theft Claims Average $17,000+", desc: "Misclassifying employees or miscalculating overtime is one of the most common — and costly — small business mistakes." },
  { icon: "⚖️", title: "Wrongful Termination Suits", desc: "Without proper documentation and procedure, even justified terminations can become expensive lawsuits." },
  { icon: "😰", title: "Hostile Workplace Litigation", desc: "Failure to have and enforce harassment policies exposes your business to EEOC investigations and jury trials." },
];

const checklistItems = [
  { title: "Offer Letter Review", desc: "Ensure every offer letter is legally sound and protects you against misrepresentation claims." },
  { title: "Handbook Annual Update", desc: "Laws change. Your handbook should be reviewed and updated every year to stay compliant." },
  { title: "Classification Audit", desc: "Are your contractors really contractors? Misclassification is the IRS and DOL's #1 enforcement target." },
  { title: "Termination Documentation", desc: "Every separation should be documented before it happens — not after a lawsuit is filed." },
];

const processSteps = [
  { num: "01", title: "HR Policy Audit", desc: "We review all existing employment documents, policies, and practices to find every gap." },
  { num: "02", title: "Custom Policy Build", desc: "We draft or update every document your business needs — handbooks, contracts, policies." },
  { num: "03", title: "Team Review & Training", desc: "We walk your leadership through all new policies and provide training documentation." },
];

const LegalEmploymentLaw = () => {
  const { navigateTo } = useNavigation();

  return (
    <div className="el-page">
      <style>{styles}</style>

      {/* ── Hero ── */}
      <section className="el-hero">
        <div className="el-hero-blob1" />
        <div className="el-hero-blob2" />
        <div className="el-hero-inner">
          <div>
            <button className="el-back-btn" onClick={() => navigateTo("")}>← Back to Legal Services</button>
            <div className="el-badge">
              <span className="el-badge-dot" />
              Employment Law Services
            </div>
            <h1>
              Protect Your Business,{" "}
              <span className="el-gradient-text">Empower Your Team</span>
            </h1>
            <p className="el-hero-sub">
              Employment law is complex, constantly changing, and unforgiving of
              mistakes. We build the legal foundation your team needs — from offer
              letters and handbooks to termination procedures and wage compliance.
            </p>
            <div className="el-btn-group">
              <button className="el-btn-primary">Get an HR Legal Audit →</button>
              <button className="el-btn-secondary">View Services</button>
            </div>
            <div className="el-trust-items">
              {["Handbooks & contracts", "Wage & hour compliance", "Termination guidance", "All 50 states"].map((t, i) => (
                <div key={i} className="el-trust-item">
                  <span className="el-trust-check">✓</span>
                  {t}
                </div>
              ))}
            </div>
          </div>

          <div className="el-hero-card">
            <div className="el-card-header">
              <div>
                <div className="el-card-title-label">Document Status</div>
                <div className="el-card-title-value">HR Legal Tracker</div>
              </div>
              <span className="el-card-live-badge">● Active</span>
            </div>
            {docItems.map((item, i) => (
              <div key={i} className="el-doc-item">
                <div className="el-doc-left">
                  <span className="el-doc-icon">{item.icon}</span>
                  <div>
                    <div className="el-doc-name">{item.name}</div>
                    <div className="el-doc-sub">{item.sub}</div>
                  </div>
                </div>
                <span className={`el-doc-badge ${item.badgeClass}`}>{item.badge}</span>
              </div>
            ))}
            <div className="el-card-metric">
              <div>
                <div className="el-metric-label">HR Policies Compliant</div>
                <div className="el-metric-value">12 / 14</div>
              </div>
              <div className="el-metric-badge">2 Need Review</div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Stats ── */}
      <section className="el-stats">
        <div className="el-stats-grid">
          {[
            { num: "1,200+", label: "Businesses Protected" },
            { num: "$2.1M+", label: "In Claims Prevented" },
            { num: "600+", label: "Handbooks Drafted" },
            { num: "All 50", label: "States Covered" },
          ].map((s, i) => (
            <div key={i} className="el-stat-item">
              <div className="el-stat-num">{s.num}</div>
              <div className="el-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Services ── */}
      <section className="el-section el-services-bg">
        <div className="el-container">
          <div className="el-section-header">
            <div className="el-kicker">Our Services</div>
            <h2>Full-Spectrum Employment Law Support</h2>
            <p>
              From the moment you make your first hire to navigating a difficult
              separation, we cover every employment law touchpoint your business
              will encounter.
            </p>
          </div>
          <div className="el-services-grid">
            {services.map((svc, i) => (
              <div key={i} className="el-svc-card">
                <div className="el-svc-icon">{svc.icon}</div>
                <div className="el-svc-title">{svc.title}</div>
                <div className="el-svc-desc">{svc.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Liability + Checklist ── */}
      <section className="el-section">
        <div className="el-container">
          <div className="el-liab-grid">
            <div className="el-liab-left">
              <div className="el-kicker">Why It Matters</div>
              <h2>Employment Mistakes Are Expensive. Prevention Is Not.</h2>
              <p>
                Most small business employment lawsuits are entirely preventable
                with the right documents and procedures in place before an issue
                arises. Here's what's at risk.
              </p>
              <div className="el-liab-items">
                {liabilities.map((l, i) => (
                  <div key={i} className="el-liab-item">
                    <div className="el-liab-icon-wrap">{l.icon}</div>
                    <div>
                      <div className="el-liab-title">{l.title}</div>
                      <div className="el-liab-desc">{l.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div className="el-kicker">Employer Checklist</div>
              <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(1.6rem, 2.5vw, 2.2rem)', fontWeight: 800, color: '#0d1b3e', letterSpacing: '-0.02em', lineHeight: 1.2, marginBottom: '32px' }}>
                Is Your Business Employment-Ready?
              </h2>
              <div className="el-checklist">
                {checklistItems.map((c, i) => (
                  <div key={i} className="el-checklist-item">
                    <div className="el-check-icon">✓</div>
                    <div>
                      <div className="el-check-title">{c.title}</div>
                      <div className="el-check-desc">{c.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Process ── */}
      <section className="el-section el-process-bg">
        <div className="el-container">
          <div className="el-section-header">
            <div className="el-kicker">How It Works</div>
            <h2>Employment-Ready in 3 Steps</h2>
            <p>We audit, build, and train — so your business is protected from day one.</p>
          </div>
          <div className="el-process-grid">
            {processSteps.map((step, i) => (
              <div key={i} className="el-process-step">
                <div className="el-process-num">{step.num}</div>
                <div className="el-process-title">{step.title}</div>
                <div className="el-process-desc">{step.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="el-cta">
        <div className="el-cta-blob1" />
        <div className="el-cta-blob2" />
        <div className="el-cta-inner">
          <div className="el-cta-tag">Free HR Legal Audit</div>
          <h2>Don't Wait for a Lawsuit to Get Compliant</h2>
          <p>
            Our free HR legal audit reviews your existing employment documents and
            practices, identifies every exposure, and gives you a clear roadmap to
            full compliance — before anything goes wrong.
          </p>
          <div className="el-cta-btn-group">
            <button className="el-cta-btn-primary">Get Free HR Audit</button>
            <button className="el-cta-btn-secondary">Talk to an Attorney</button>
          </div>
          <div className="el-cta-reassurances">
            {["Free audit", "All 50 states", "No obligation", "Same-day scheduling"].map((r, i) => (
              <div key={i} className="el-cta-reassurance">
                <span className="el-cta-check">✓</span>
                {r}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalEmploymentLaw;
